import { Formik, Form as FormFormik } from 'formik'
import React, { useState } from 'react'
import { parseISO, isValid as isValidDateFns, formatISO } from 'date-fns'
import InputMask from 'react-input-mask'
import { MdDateRange, MdKeyboardArrowDown, MdSend } from 'react-icons/md'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import typesInteration from '../../commons/TypeInteration/types'
import typesCategories from '../../commons/Category/types'
import TypeInteration from '../../commons/TypeInteration/TypeInteration'
import Text from '../../commons/Text/Text'
import Tag from '../../commons/Tag/Tag'
import TimelineMatrizModal from '../../commons/TimelineMatrizModal/TimelineMatrizModal'
import CustomerModal from '../../commons/CustomerModal/CustomerModal'
import Button from '../../commons/Button/Button'
import Flex from '../../commons/Flex/Flex'
import styles from './timelineForm.module.scss'

const ENUM_INTERATIONS = Object.values(typesInteration)

const validationSchema = Yup.object().shape({
  store_wallet_identifier: Yup.string().required('Selecione um cliente'),
  date: Yup.string().required('Informe uma data'),
  indicators: Yup.array().max(4, 'Pode ser seleionado no máximo 4'),
  category_id: Yup.number().required('Selecione uma categoria'),
  interaction_id: Yup.number().required('Selecione um tipo de interação'),
  description: Yup.string()
    .min(10, 'Favor informar uma descrição mais longa')
    .required('Informe uma descrição')
})

const initialValue = {
  store_wallet_identifier: '',
  date: '',
  indicators: [],
  category_id: '',
  interaction_id: ENUM_INTERATIONS[0],
  description: ''
}

const TimelineForm = ({ handleSubmit }) => {
  const [showMatrizFilter, setShowMatrizFilter] = useState(false)
  const [showModalCustomer, setShowModalCustomer] = useState(false)
  const [clientWalletCode, setClientWalletCode] = useState()
  const [client, setClient] = useState()

  return (
    <Formik
      initialValues={initialValue}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ setFieldValue, setFieldError, values, errors, isValid }) => {
        const disabled = !isValid

        return (
          <FormFormik>
            <TimelineMatrizModal
              visible={showMatrizFilter}
              clientWalletCode={clientWalletCode}
              onConfirm={(selecteds) => {
                setShowMatrizFilter(false)
                setFieldValue('indicators', selecteds)
              }}
              initialValues={values.indicators}
            />
            <CustomerModal
              visible={showModalCustomer}
              onSelect={(item) => {
                setFieldValue(
                  'store_wallet_identifier',
                  parseInt(item.walletCode, 10)
                )
                setClient(item.nameFantasy)
                setClientWalletCode(item.walletCode)
                setShowModalCustomer(false)
              }}
            />
            <div className={styles.container}>
              <div className={styles.field}>
                {errors.description && (
                  <div className={styles.feedback}>
                    <span>{errors.description}</span>
                  </div>
                )}
                <textarea
                  className={styles.textarea}
                  placeholder="Detalhe sua interação"
                  name="description"
                  value={values.description}
                  onChange={(e) => setFieldValue('description', e.target.value)}
                />
                <Flex alignItems="center" justifyContent="flex-end">
                  <Text
                    value={
                      values.description.length === 0
                        ? '0'
                        : values.description.length
                    }
                    color="gray"
                    variation="light"
                    size="xxs"
                  />
                </Flex>
                <div className={styles.types}>
                  <Text size="md" color="gray" variation="dark" extraBold>
                    Tipo de interação
                  </Text>
                  <div className={styles.typesList}>
                    {ENUM_INTERATIONS.map((item) => (
                      <TypeInteration
                        onClick={() => setFieldValue('interaction_id', item)}
                        key={item}
                        type={item}
                        active={item === values.interaction_id}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className={styles.options}>
                <div className={styles.optionsForm}>
                  <div className={styles.formControl}>
                    <Tag
                      text={client ?? 'Cliente'}
                      onClick={() => setShowModalCustomer(true)}
                      Icon={() => <MdKeyboardArrowDown color="#4D4D4D" />}
                    />
                    {errors.store_wallet_identifier && (
                      <div className={styles.feedback}>
                        <span>{errors.store_wallet_identifier}</span>
                      </div>
                    )}
                  </div>

                  <div className={styles.formControl}>
                    <Tag
                      text="Matriz de prioridades"
                      quantity={values.indicators.length}
                      active={values.indicators.length > 0}
                      onClick={() => setShowMatrizFilter(true)}
                      Icon={() => <MdKeyboardArrowDown color="#4D4D4D" />}
                      disabled={!clientWalletCode}
                    />

                    {errors.indicators && (
                      <div className={styles.feedback}>
                        <span>{errors.indicators}</span>
                      </div>
                    )}
                  </div>

                  <div className={styles.inputContainer}>
                    <InputMask
                      className={styles.input}
                      mask="99/99/9999"
                      onChange={(e) => {
                        const value = e.target.value.split('/')
                        const parsed = parseISO(
                          `${value[2]}-${value[1]}-${value[0]} 00:00:00`
                        )

                        if (isValidDateFns(parsed)) {
                          const formated = formatISO(parsed)
                          setFieldValue('date', formated)
                        } else {
                          setFieldError('date', 'Data inválida')
                        }
                      }}
                      defaultValue={values.date}
                    />
                    <div className={styles.inputIcon}>
                      <MdDateRange color="#737373" />
                    </div>

                    {errors.date && (
                      <div className={styles.feedback}>
                        <span>{errors.date}</span>
                      </div>
                    )}
                  </div>

                  <div className={styles.sectionCategory}>
                    {errors.category_id && (
                      <div className={styles.feedback}>
                        <span>{errors.category_id}</span>
                      </div>
                    )}

                    <Text color="gray" variation="dark" size="sm" font="custom">
                      Categoria
                    </Text>

                    <div className={styles.listTag}>
                      <Tag
                        text="Problema"
                        onClick={() => {
                          setFieldValue('category_id', typesCategories.PROBLEMS)
                        }}
                        active={values.category_id === typesCategories.PROBLEMS}
                      />
                      <Tag
                        text="Treinamento"
                        onClick={() => {
                          setFieldValue('category_id', typesCategories.TRAINING)
                        }}
                        active={values.category_id === typesCategories.TRAINING}
                      />
                      <Tag
                        text="Oferta"
                        onClick={() => {
                          setFieldValue('category_id', typesCategories.OFFER)
                        }}
                        active={values.category_id === typesCategories.OFFER}
                      />
                      <Tag
                        text="Plano de ação"
                        onClick={() => {
                          setFieldValue(
                            'category_id',
                            typesCategories.ACTION_PLAN
                          )
                        }}
                        active={
                          values.category_id === typesCategories.ACTION_PLAN
                        }
                      />
                      <Tag
                        text="Dúvidas"
                        onClick={() => {
                          setFieldValue('category_id', typesCategories.DOUBTS)
                        }}
                        active={values.category_id === typesCategories.DOUBTS}
                      />
                    </div>
                  </div>
                </div>
                <Button
                  buttonType="submit"
                  type="secondary"
                  full
                  disabled={disabled}
                >
                  <Text
                    color="white"
                    size="xs"
                    lineHeight="16px"
                    extraBold
                    margin="0px 9px 0px 0px"
                  >
                    Publicar
                  </Text>
                  <MdSend color="white" />
                </Button>
              </div>
            </div>
          </FormFormik>
        )
      }}
    </Formik>
  )
}

TimelineForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired
}

export default TimelineForm
